/* eslint-disable @typescript-eslint/no-explicit-any */
import { createErrorOperationResult } from '../create-error-operation-result';
import { createSuccessOperationResult } from '../create-success-operation-result';
import type { IOperation } from '../types';

export function withTryCatchOpResult<
  const TFunction extends IOperation<any[], any, any>,
>(
  call: (
    ...args: Parameters<TFunction>
  ) => Promise<
    TFunction extends IOperation<any[], infer TResponse, any>
      ? TResponse
      : never
  >,
  error: TFunction extends IOperation<any[], any, infer TError>
    ? TError
    : never,
): TFunction {
  return (async (...args: Parameters<TFunction>) => {
    try {
      const response = await call(...args);
      return createSuccessOperationResult(response);
    } catch (e) {
      // PATCH: NextJS needs exceptions not to be caught
      if (e instanceof Error && e.message.includes('NEXT_REDIRECT')) {
        throw e;
      }

      return createErrorOperationResult({
        errors: [
          {
            code: error,
            rootCause: e instanceof Error ? e : new Error(String(e)),
          },
        ],
      });
    }
  }) as TFunction;
}
